import { useDataTable } from 'hooks/useDataTable';
import { Grid } from 'common/containers';
import DataTable from 'common/dataTable';
import Search from 'common/tableFilters/search';
import moment from 'moment';
import { formatNumber } from 'utils/formatData';
const ExpensesTable = () => {
	const {
		response,
		isLoading,
		totalDocs,
		perPage,
		handlePageChange,
		handlePerRowsChange,
		search,
		setSearch,
		showHidden,
		setShowHidden,
	} = useDataTable('expenses', [{ name: null, value: null }], 0);
	const columns = [
		{
			name: 'Nombre',
			selector: (row: any) => row.name,
			sortable: true,
			wrap: true,
		},
		{
			name: 'Fecha',
			selector: (row: any) => moment(row.createdAt).format('DD/MM/YYYY'),
			sortable: true,
			wrap: true,
		},
		{
			name: 'Cantidad',
			selector: (row: any) => formatNumber(row.quantity),
			sortable: true,
			wrap: true,
		},
		{
			name: 'Tarjeta',
			selector: (row: any) => row.paymentMethod[0].bank,
			sortable: true,
			wrap: true,
		},
	];

	return (
		<>
			<Grid
				$columns={2}
				$separator="1rem">
				<Search
					search={search}
					setSearch={setSearch}
				/>
			</Grid>
			<DataTable
				data={response}
				columns={columns}
				progressPending={isLoading}
				pagination
				paginationServer
				paginationTotalRows={totalDocs}
				onChangeRowsPerPage={handlePerRowsChange}
				onChangePage={handlePageChange}
				paginationPerPage={perPage}
				toggleHidden={false}
				showHidden={showHidden}
				setShowHidden={setShowHidden}
			/>
		</>
	);
};
export default ExpensesTable;
